import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../templates/navbar/Navbar'
import ContributorList from '../../templates/contributor-list/ContributorList'
import ContributorListHeader from '../../templates/contributor-list/ContributorListHeader'

export default function ContributorListPage(props) {
  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="section">
          <ContributorListHeader />
          <div className="has-text-right">
            <Link className="button is-primary" to="/contributor/create">
              + Create
            </Link>
          </div>
          <hr/>
          <ContributorList {...props} />
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/web/ContributorListPage.js